import appMixin from "../mixins/app-mixin";
import axios from "axios";
import i18n from "@/_plugins/i18n";
import appOauthMixin from "./app-oauth-mixin";
import userSettings from "@/_mixins/user-settings-mixin";
import notificationMixin from "@/_mixins/notification-mixin";

export default {
  data() {
    return {
      resource: "", //todo: used?
      showDebugInfo: false, //todo: used?
      autoLogin: true, //todo: used?
    };
  },
  mixins: [appMixin, appOauthMixin, userSettings, notificationMixin],
  mounted() {
    this.handleAppColors();
  },
  computed: {
    isLoggedIn() {
      return !!this.credentials;
    },
    requestHeaders() {
      var returnValue = {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,POST,OPTIONS,DELETE,PUT",
      };
      if (!!this.credentials) {
        returnValue[
          "Authorization"
        ] = `bearer ${this.credentials.access_token}`;
      }

      return returnValue;
    },
    fileHeaders() {
      var returnValue = {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,POST,OPTIONS,DELETE,PUT",
        "Content-Type": "multipart/form-data",
      };
      if (!!this.credentials) {
        returnValue[
          "Authorization"
        ] = `bearer ${this.credentials.access_token}`;
      }
      return returnValue;
    },
  },
  watch: {},
  methods: {
    handleAppColors() {
      //Override top bar color for Dev and STG env
      if(this.settings.environment == "DEV"){
        this.globalTopBarColor = this.settings.env_color_dev;
      }
      else if(this.settings.environment == "STG"){
        this.globalTopBarColor = this.settings.env_color_stg;
      }
    },
    request(url, options) {
      var config = Object.assign(
        {
          method: "get",
          url: url,
          data: null,
          headers: this.requestHeaders,
          withCredentials: true,
        },
        options
      );
      try {
        return axios(config);
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    getMyInfoPost() {
      return this.request(`${this.settings.apiUrl}/.auth/me`, {
        method: "post",
      });
    },
    // todo: this should be a generic call for both Vendor and Financial Master Data ?
    getUser() {
      this.marApp_pageTitle = "Medical Application Request";
      var self = this;
      console.log(this.pagetitle);
      //window.pagetitle = "MyHome"; //"Data Quality Platform" //bad practice, use route name or marApp_pageTitle
      window.pagetitle = self.marApp_pageTitle;
      if (!self.marApp_userDetails?.userEmail) {
        axios
          .get(this.settings.apiUrl + "/usercontext/GetUser", {
            withCredentials: true,
            headers: self.requestHeaders,
          })
          .then((response) => {
            self.marApp_userDetails = response.data;
            // self.getGlobalMasterDataFromAPI();
          })
          .catch((error) => console.log(error));
      }
    },
    getCurrentUserRole() {
      //todo: move user Props to the Store User object
      var self = this;
      self.isPageLoading = true;
      const link =
        this.settings.apiUrl +
        "/User/GetUserRolesByEmail?email=" +
        self.marApp_userDetails.userEmail;
      axios
        .get(link, {
          withCredentials: true,
          headers: self.requestHeaders,
        })
        .then((response) => {
          if (response.data != null && response.data.length > 0) {
            if (response.data.find((x) => x.roleId == self.dqpAdmin) != null) {
              self.isDqpAdmin = true;
            }
            if (
              response.data.find((x) => x.roleId == self.vendorWFAdmin) != null
            ) {
              self.isVendorWFAdmin = true;
              self.isAnyApprover = true;
            }
            if (
              response.data.find(
                (x) =>
                  x.roleId == 2 ||
                  x.roleId == 4 ||
                  x.roleId == 5 ||
                  x.roleId == 6 ||
                  x.roleId == 7 ||
                  x.roleId == 155
              ) != null
            ) {
              self.isAnyApprover = true;
            }

            if (
              response.data.find((x) => x.roleId == self.financeAdmin) != null
            ) {
              self.isFinanceAdmin = true;
            }
          }
        })
        .catch((error) => console.log(error));
    },
    getProfilePic() {
      var self = this;
      const linkgetId = this.settings.apiUrl + "/MyDirectory/users/myphoto";
      axios
        .get(linkgetId, {
          withCredentials: true,
          headers: this.requestHeaders,
        })
        .then((response) => {
          if (response.data != "") {
            self.user.profilePic = "data:image/jpg;base64,".concat(response.data);
          }
          else self.user.profilePic = "";

          self.marApp_userDetails = self.user;
        })
        .catch((error) => console.log(error));
    },
  },
};
